export type RequestAdagaPinPad = {
  type: "debit-card" | "credit-card"; // credit-card ou debit-card
  amount: number; // VALOR EM CENTAVOS
  service: string; // DEIXAR ESSE VALOR FIXO
  timeout: number; // TIMEOUT DO PINPAD EM SEGUNDOS
  installments: number; // QUANTIDADE DE PARCELA [OPCIONAL]
  entryAmount: null; // VALOR DE ENTRADA [OPCIONAL]
  externalId: string; // VALOR DO IDPAGAMENTO
  urlNotification: string; // URL DO WEBHOOK QUER SERA CHAMADO PARA INFORMAR O STATUS DO PAGAMENTO
};

export type ResponseAdagaPinPad = {
  authorizationCode?: null | string | number;
  capture?: string;
  cardBrand?: string;
  cardHolder?: null | string | number;
  cardNumber?: null | string | number;
  document?: string;
  entryAmount?: null | string | number;
  id?: string;
  installments?: number;
  mcc?: string;
  nsu?: null | string | number;
  originalAmount?: string;
  receipt?: string;
  serialNumber?: string;
  service?: string;
  status?: string;
  statusReason?: string;
  tefNsu?: string;
  totalAmount?: string;
  type?: string;
};

export const msgFeedbacks = {
  init: "Tudo certo! Iniciamos o pagamento com o teu cartão. Confirme no Pinpad o valor selecionado e aproxime ou insira o teu cartão.",
  timeout:
    "O tempo máximo de espera do pinpad foi atingido. Por favor tente novamente!",
  failure:
    "Houve algum problema e o pagamento não foi realizado. O pagamento foi cancelado ou reprovado. Por favor tente novamente!",
  success:
    "Recebemos o teu pagamento! Aguarde que estamos atualizando a tua fatura.",
  notWork: "Tente novamente mais tarde! (Erro de comunicação pinpad)!",
  notEndBackoffice: "Tente novamente mais tarde! (Erro ao finalizar pagamento)",
};
